import { type InsuranceCorporateIdentity } from "../types";

export function SecurvitaLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_31_4081">
          <rect
            width="429"
            height="155"
            fill="white"
            transform="translate(42 197)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_31_4081)">
        <path
          d="M304.722 232.874L309.481 249.928C309.481 249.928 311.981 258.554 324.24 246.053L370.775 200.815C370.775 200.815 377.598 193.004 381.664 199.684C384.842 204.902 379.39 211.959 379.39 211.959C379.39 211.959 352.357 252.462 319.029 281.474C318.502 281.942 318.111 282.153 317.297 282.786C314.782 284.716 293.367 298.77 285.671 275.141C277.976 251.512 282.93 233.552 291.891 227.415C300.852 221.278 304.752 232.859 304.752 232.859L304.722 232.874Z"
          fill="#E30613"
        />
        <path
          d="M82.6621 270.074C82.6621 250.577 57.9937 254.995 57.9937 245.118C57.9937 241.363 60.9003 238.951 67.0298 238.951C70.7902 238.953 74.5333 239.46 78.1591 240.459L78.6411 228.244C75.011 227.591 71.3348 227.228 67.6472 227.159C50.7047 227.159 42.1205 235.859 42.1205 246.4C42.1205 266.862 66.4274 260.816 66.4274 271.477C66.4274 275.473 62.557 277.885 56.6233 277.885C52.2533 277.817 47.9083 277.209 43.6867 276.076L43.3253 288.773C47.4829 289.459 51.6868 289.827 55.9004 289.873C72.346 289.873 82.7374 281.881 82.7374 270.014"
          fill="#1D1D1B"
        />
        <path
          d="M125.192 250.577H103.038C103.882 243.308 108.37 238.513 114.785 238.513C121.201 238.513 125.433 243.037 125.192 250.577ZM140.538 254.09C140.538 239.192 132.797 227.219 115.267 227.219C97.195 227.219 87.0897 240.79 87.0897 259.172C87.0897 280.373 97.7221 289.934 116.833 289.934C124.194 289.98 131.5 288.666 138.384 286.058L136.878 273.995C131.364 276.469 125.391 277.748 119.348 277.749C108.219 277.749 102.647 272.306 102.782 261.027H140.041C140.377 258.705 140.543 256.361 140.538 254.015"
          fill="#1D1D1B"
        />
        <path
          d="M188.203 287.023L186.998 273.829C183.292 275.569 179.239 276.441 175.146 276.377C164.86 276.377 160.869 269.35 160.869 259.051C160.869 247.666 165.824 240.398 175.628 240.398C179.356 240.478 183.042 241.213 186.516 242.57L188.022 229.149C184.004 228.039 179.856 227.471 175.688 227.46C154.408 227.46 144.619 241.846 144.619 260.635C144.619 281.112 155.01 289.813 171.727 289.813C177.328 289.852 182.893 288.913 188.173 287.038"
          fill="#1D1D1B"
        />
        <path
          d="M414.841 288.35V275.895C412.383 276.537 409.852 276.861 407.311 276.86C401.98 276.86 400.173 274.673 400.173 266.923V240.519H414.811V228.546H400.173V205.927L384.706 210.029V228.576H374.42V240.549H384.827V271.085C384.827 285.123 388.938 289.964 402.221 289.964C406.465 289.936 410.692 289.405 414.811 288.381"
          fill="#1D1D1B"
        />
        <path
          d="M455.307 276.543C452.819 277.847 450.059 278.545 447.25 278.579C440.609 278.956 436 275.307 436.422 270.24C436.949 263.967 441.844 261.464 455.262 261.464V276.543H455.307ZM470.548 248.028C470.548 234.955 465.096 227.083 445.744 227.083C438.41 227.129 431.135 228.409 424.223 230.868L425.549 243.821C431.022 240.863 437.117 239.246 443.335 239.101C452.039 239.101 455.066 242.374 455.066 248.662L455.202 252.13C438.38 251.497 422.733 257.031 420.639 269.743C418.847 280.554 427.356 290.567 447.1 290.009C457.521 289.708 465.729 288.049 470.774 285.35L470.548 248.059V248.028Z"
          fill="#1D1D1B"
        />
        <path
          d="M289.918 227.385C273.653 226.601 264.241 228.41 257.509 231.652V288.727H272.9V241.77C275.822 240.428 284.873 240.262 289.241 241.499L289.918 227.385Z"
          fill="#1D1D1B"
        />
        <path
          d="M247.705 285.365V228.425H232.073V274.538C230.702 275.895 223.82 277.659 219.648 276.905C212.811 275.669 211.395 273.708 210.958 267.028C210.958 264.54 210.958 228.44 210.958 228.44H195.206C195.206 228.44 195.206 268.31 195.281 272.004C195.417 286.465 209.829 289.813 220.717 290.1C232.043 290.401 242.088 288.2 247.705 285.395"
          fill="#1D1D1B"
        />
        <path
          d="M350.49 228.531V247.621V288.712H365.941V230.868V228.531H350.49Z"
          fill="#1D1D1B"
        />
        <path
          d="M358.261 222.409C360.787 222.433 363.22 221.455 365.028 219.689C366.837 217.924 367.875 215.513 367.914 212.984C367.908 211.418 367.502 209.88 366.735 208.516C365.968 207.151 364.865 206.006 363.532 205.188C361.951 204.201 360.124 203.678 358.261 203.68C355.764 203.652 353.358 204.615 351.569 206.358C349.779 208.102 348.752 210.484 348.713 212.984C348.698 214.814 349.222 216.607 350.219 218.141C351.094 219.46 352.283 220.54 353.679 221.285C355.075 222.03 356.634 222.416 358.216 222.409H358.261Z"
          fill="#1D1D1B"
        />
      </g>
    </svg>
  );
}

export const Securvita: InsuranceCorporateIdentity = {
  id: "securvita",
  name: "securvita BKK",
  logo: SecurvitaLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "securvita bkk",
  type: "statutory",
};
